import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { injectGlobalStyles } from './styles'
import moment from 'moment'
import { timer } from 'countdown-js'
import Introduction from './components/Introduction'
import Overlay from './components/Overlay'
import Lyrics from './components/Lyrics'
import Player from './components/Player'
import SoundCloudPlayer from './components/SoundCloudPlayer'
import Countdown from './components/Countdown'
import constants from './constants'
import songs from './songs'
import styled from 'styled-components'
import queryString from 'query-string'

// Navigation lets visitors browse all 14 songs freely. It's on by default for
// the archived site; append ?navigation=false to restore the original
// one-song-per-day timed reveal.
const ENABLE_NAVIGATION = queryString.parse(window.location.search).navigation !== 'false'

const AppWrapper = styled.div`
  opacity: 0;
  height: 100%;
  background: #0c181b;
  html.wf-active & {
    transition: opacity 0.3s;
    opacity: 1;
  }
`
const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 50;
  display: flex;
  padding: 10px;
  justify-content: ${props => props.pullRight ? 'flex-end' : 'space-between'};
  align-items: flex-end;
  transition: background-color 0.3s;
  background: ${props => props.pullRight || props.active === constants.SHOW_LYRIC
    ? 'rgba(0, 0, 0, 0.2)'
    : 'rgba(0, 0, 0, 0)'};
`

const initialDate = '2016-10-29'
const today = moment()

class App extends Component {
  constructor () {
    super()

    injectGlobalStyles()

    this.handleStart = this.handleStart.bind(this)
    this.toggleOverlay = this.toggleOverlay.bind(this)
    this.playSong = this.playSong.bind(this)

    this.songs = songs.map((day, index) => {
      day.next = songs[index + 1]
      return day
    })

    this.state = {start: false, day: this.isValidDay() || this.songs[0], time: '...', end: false, overlay: false,
                  active: constants.SHOW_LYRIC, displayIntroduction: true, animating: false,
                  isBefore: moment(initialDate).isAfter(today, 'day'),
                  isAfter: moment(initialDate).add(songs.length - 1, 'days').isBefore(today, 'day')}
  }
  componentDidMount () {
    var end = new Date(moment().endOf('day'))
    this.timer = timer(end, (time) => {
      this.setState({time: moment(time).format('HH:mm:ss')})
    }, () => {
      this.setState({end: true}, () => {
        window.location.reload(true)
      })
    })
  }
  handleStart () {
    let introduction = ReactDOM.findDOMNode(this.refs.introduction)
    introduction.style.opacity = 0
    introduction.style.pointerEvents = 'none'
    this.setState({start: true})
    window.setTimeout(() => {
      this.setState({displayIntroduction: false})
    }, 500)
  }
  isValidDay () {
    return this.songs.find((day, index) => {
      let valid = moment(initialDate).add(index, 'days').isSame(today, 'day')
      return valid ? day : false
    })
  }
  toggleOverlay () {
    let overlay = !this.state.overlay
    let active = !this.state.overlay ? constants.SHOW_OVERLAY : constants.SHOW_LYRIC
    let start = {animating: true, active: active}
    let end = {animating: false}
    if (overlay) {
      start.overlay = true
      end.overlay = true
    } else {
      start.overlay = true
      end.overlay = false
    }
    this.setState(start, () => {
      if (this.animationTimer) window.clearTimeout(this.animationTimer)
      this.animationTimer = window.setTimeout(() => {
        this.setState(end)
      }, 500)
    })
  }
  playSong (day, soundCloudAudio) {
    this.setState({day: day}, () => {
      if (this.load) window.clearTimeout(this.load)
      this.load = window.setTimeout(() => {
        soundCloudAudio.resolve(day.track, () => {
          soundCloudAudio.play()
        })
      }, 1000)
    })
  }
  render () {
    let sharedProps = {
      animating: this.state.animating,
      active: this.state.active
    }
    let gated = (this.state.isBefore || this.state.isAfter) && !ENABLE_NAVIGATION
    return (
      <AppWrapper>
        {gated
          ? <div>
              <Lyrics lyric='0-intro' active={constants.SHOW_LYRIC} enableZooming displayLyric />
              {this.state.isBefore && <Footer pullRight>
                <Countdown time={this.state.time} />
              </Footer>}
            </div>
          : <div>
            <Footer active={this.state.active}>
              {this.state.day.track && <SoundCloudPlayer resolveUrl={this.state.day.track}>
                <Player controls={ENABLE_NAVIGATION} autoplay={this.state.start} playSong={this.playSong} day={this.state.day} songs={this.songs} {...sharedProps} />
              </SoundCloudPlayer>}
              <Overlay {...sharedProps} displayNavigation={ENABLE_NAVIGATION} toggleOverlay={this.toggleOverlay} displayOverlay={this.state.overlay} />
              {!ENABLE_NAVIGATION && <Countdown {...sharedProps} next={this.state.day.next} time={this.state.time} />}
            </Footer>
            <Lyrics {...sharedProps} lyric={this.state.day.lyric} active={this.state.active} enableZooming={!this.state.overlay && !this.state.animating} displayLyric={!this.state.overlay || this.state.animating} />
          </div>
        }
        {this.state.displayIntroduction && <Introduction ref='introduction' handleStart={this.handleStart} />}
      </AppWrapper>
    )
  }
}

export default App



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/